import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
  {
    path: '/customer-invoices',
    name: 'customer-invoices-list',
    component: () => import(/* webpackChunkName: "customer-invoices" */ './pages/CustomerInvoiceListPage.vue')
  },
  {
    path: '/customer-invoices/:id',
    name: 'customer-invoices-read',
    component: () => import(/* webpackChunkName: "customer-invoices" */ './pages/CustomerInvoiceReadPage.vue')
  }
]

export default routes
